const win = window as any;

export default function (getState: () => string) {
  if (win.__SSR__) {
    Array.from(document.querySelectorAll('[data-jss-snap]')).forEach(
      (elem) => elem.parentNode && elem.parentNode.removeChild(elem)
    );

    delete win.__PRELOADED_STATE__;
  } else {
    win.snapSaveState = () => {
      Array.from(document.querySelectorAll('[data-jss]')).forEach((elem) =>
        elem.setAttribute('data-jss-snap', '')
      );

      return {
        __SSR__: true,
        __PRELOADED_STATE__: getState(),
      };
    };
  }
}
